import React, { useState } from 'react';
import '../assets/SearchCustomer.css';

const SearchCustomer = () => {
  const [customer, setCustomer] = useState(null); // will hold API data later

  return (
    <div className="SearchCustomer-container">
      {/* Search Input */}
      <div className="SearchCustomer-searchBox">
        <input
          type="text"
          placeholder="Enter Customer ID"
          className="SearchCustomer-input"
        />
        <button className="SearchCustomer-button">Search</button>
      </div>

      {/* Customer Info Section */}
      <div className="SearchCustomer-customerInfoCard">
        <div className="SearchCustomer-profileImage">
          {/* Empty initially, will show fetched image */}
          <img
            src={customer?.profileImage || ""}
            alt="Customer"
          />
        </div>
        <div className="SearchCustomer-customerDetails">
          <h2>Customer Information</h2>
          <div className="SearchCustomer-grid">
            <div className="SearchCustomer-item"><label>Customer ID:</label> {customer?.id || ""}</div>
            <div className="SearchCustomer-item"><label>Name:</label> {customer?.name || ""}</div>
            <div className="SearchCustomer-item"><label>Email:</label> {customer?.email || ""}</div>
            <div className="SearchCustomer-item"><label>Phone:</label> {customer?.phone || ""}</div>
            <div className="SearchCustomer-item"><label>Address:</label> {customer?.address || ""}</div>
            <div className="SearchCustomer-item"><label>Aadhar:</label> {customer?.aadhar || ""}</div>
            <div className="SearchCustomer-item"><label>PAN:</label> {customer?.pan || ""}</div>
            <div className="SearchCustomer-item"><label>Branch Name:</label> {customer?.branchName || ""}</div>
            <div className="SearchCustomer-item"><label>Branch Code:</label> {customer?.branchCode || ""}</div>
          </div>
        </div>
      </div>

      {/* Account Cards */}
      <div className="SearchCustomer-accountSection">
        {/* Loan Account */}
        <div className="SearchCustomer-card">
          <h3>Loan Account #: {customer?.loanAccount?.number || ""}</h3>
          <div className="SearchCustomer-grid">
            <div className="SearchCustomer-item"><label>Loan Amount:</label> {customer?.loanAccount?.amount || ""}</div>
            <div className="SearchCustomer-item"><label>Interest Rate:</label> {customer?.loanAccount?.interestRate || ""}</div>
            <div className="SearchCustomer-item"><label>Regular EMI:</label> {customer?.loanAccount?.emi || ""}</div>
            <div className="SearchCustomer-item"><label>Last EMI:</label> {customer?.loanAccount?.lastEmi || ""}</div>
            <div className="SearchCustomer-item"><label>Total Interest:</label> {customer?.loanAccount?.totalInterest || ""}</div>
            <div className="SearchCustomer-item"><label>Tenure:</label> {customer?.loanAccount?.tenure || ""}</div>
            <div className="SearchCustomer-item"><label>Disbursal Date:</label> {customer?.loanAccount?.disbursalDate || ""}</div>
            <div className="SearchCustomer-item"><label>Closure Date:</label> {customer?.loanAccount?.closureDate || ""}</div>
          </div>
        </div>

        {/* Deposit Account */}
        <div className="SearchCustomer-card">
          <h3>Deposit Account #: {customer?.depositAccount?.number || ""}</h3>
          <div className="SearchCustomer-grid">
            <div className="SearchCustomer-item"><label>Installment Amount:</label> {customer?.depositAccount?.installmentAmount || ""}</div>
            <div className="SearchCustomer-item"><label>Installment Frequency:</label> {customer?.depositAccount?.installmentFrequency || ""}</div>
            <div className="SearchCustomer-item"><label>Interest Rate:</label> {customer?.depositAccount?.interestRate || ""}</div>
            <div className="SearchCustomer-item"><label>Tenure:</label> {customer?.depositAccount?.tenure || ""}</div>
            <div className="SearchCustomer-item"><label>Maturity Amount:</label> {customer?.depositAccount?.maturityAmount || ""}</div>
            <div className="SearchCustomer-item"><label>Approval Date:</label> {customer?.depositAccount?.approvalDate || ""}</div>
            <div className="SearchCustomer-item"><label>Maturity Date:</label> {customer?.depositAccount?.maturityDate || ""}</div>
            <div className="SearchCustomer-item"><label>Deposit Type:</label> {customer?.depositAccount?.type || ""}</div>
          </div>
        </div>

        {/* Saving Account */}
        <div className="SearchCustomer-card">
          <h3>Saving Account #: {customer?.savingAccount?.number || ""}</h3>
          <div className="SearchCustomer-grid">
            <div className="SearchCustomer-item"><label>Balance:</label> {customer?.savingAccount?.balance || ""}</div>
            <div className="SearchCustomer-item"><label>Hold Amount:</label> {customer?.savingAccount?.holdAmount || ""}</div>
            <div className="SearchCustomer-item"><label>Lockin Amount:</label> {customer?.savingAccount?.lockinAmount || ""}</div>
            <div className="SearchCustomer-item"><label>Cash Withdrawal Limit:</label> {customer?.savingAccount?.withdrawalLimit || ""}</div>
            <div className="SearchCustomer-item"><label>Fund Transfer Limit:</label> {customer?.savingAccount?.transferLimit || ""}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchCustomer;
